import { render } from "./BookAppointmentPopup.vue?vue&type=template&id=c2c6a35e"
import script from "./BookAppointmentPopup.vue?vue&type=script&lang=js"
export * from "./BookAppointmentPopup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nexgen/apps/nxglabs-web/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__